module.exports = __webpack_public_path__ + "img/star.37c5b536.png";